<template>
  <div class="row fixed-bottom bg-light px-3 py-2 small">
    <div class="col">
      {{ version }}
    </div>
    <div class="col text-right">
      <mz-date-display :timestamp="timestamp"></mz-date-display>
    </div>
  </div>  
</template>

<script>
import DateDisplay from '@/components/general/DateDisplay'

import { mapGetters } from 'vuex'

export default {
  name: 'app-footer',
  data () {
    return {
      timestamp: Date.now()
    }
  },
  computed: {
    ...mapGetters(['version'])
  },
  components: {
    mzDateDisplay: DateDisplay
  },
  created () {
    setInterval(() => {
      this.timestamp = Date.now()
    }, 1000)
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/layout/Footer.vue